
<div class="app-left-margin w-100" style="padding-right: 75px;">
    <d-inbox
        v-model="showInbox"
    />

    <d-inc-outbox
        v-model = "showOutbox"
    />

    <v-app-bar color="white" elevation="0"  height="45">
        <v-app-bar-nav-icon
            @click = "drawer=true"
            class  = "primary--text"
            style  = "margin-top: -2px"
        />

        <v-toolbar-title class="primary--text"><span>LIFTMANAGER</span><span v-if="!isProd" class="ml-3 red--text" style="font-weight: normal">(Testsystem)</span></v-toolbar-title>

        <div class="v-flex ml-5 mr-3" style="height: 32px; ">
            <c-toolbar-button
                icon     = "mdi-home"
                :color   = "style.color"
                :size    = "style.size"
                :tooltip = "$t('home.button')"
                @click   = "onHome"
            />

            <c-app-recent-incident
                v-if = "liftmanager"
            />

            <c-app-recent-site
                v-if = "liftmanager"
            />

            <c-toolbar-button
                v-if     = "liftmanager"
                icon     = "mdi-inbox"
                :color   = "style.color"
                :size    = "style.size"
                :tooltip = "$t('inb.button.messages')"
                @click   = "onInbox"
            />

            <c-toolbar-button
                v-if     = "liftmanager"
                icon     = "mdi-inbox-arrow-up"
                :color   = "style.color"
                :size    = "style.size"
                tooltip  = "Outbox"
                @click   = "onOutbox"
            />

            <!--
            <c-toolbar-button
                v-if     = "liftmanager"
                icon     = "mdi-calendar-week"
                :color   = "style.color"
                :size    = "style.size"
                :tooltip = "$t('crm.button.week')"
                @click   = "onCalendar"
            />
            -->
        </div>

        <c-app-home-search
            :categories = "['site', 'incident']"
            :search-on-focus = "searchOnFocus"
        />

        <v-spacer/>

        <div class="float-right" style="display: flex">
            <crm-top-reminder-menu
                v-if="liftmanager"
                v-model="reminder"
            />

            <inb-message-menu
                v-if="liftmanager"
                v-model="messages"
            />

            <c-inc-clipboard-menu
                v-if="liftmanager"
                v-model="clipboard"
            />

            <nav-user-menu />
        </div>
    </v-app-bar>

    <v-navigation-drawer
        v-model="drawer"
        absolute
        temporary
    >
        <c-app-side-drawer
            :show="drawer"
        />
    </v-navigation-drawer>

    <v-navigation-drawer
        v-model = "messages"
        :left   = "!drawerRight"
        :right  = "drawerRight"
        width   = "500"
        hide-overlay
        stateless
        absolute
        temporary
    >
        <inbox-message-drawer
            :open="messages"
            @close="onClose"
            @position="onPosition"
        />
    </v-navigation-drawer>

    <v-navigation-drawer
        v-model = "reminder"
        width   = "500"
        :left   = "!drawerRight"
        :right  = "drawerRight"
        absolute
        temporary
    >
        <crm-reminder-drawer
            @close="onClose"
            @position="onPosition"
        />
    </v-navigation-drawer>

    <v-navigation-drawer
        v-model = "clipboard"
        width   = "500"
        :left   = "!drawerRight"
        :right  = "drawerRight"
        hide-overlay
        stateless
        absolute
        temporary
    >
        <c-inc-clipboard-drawer
            @close    = "onClose"
            @position = "onPosition"
        />
    </v-navigation-drawer>
</div>
